"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScaleExtent = getScaleExtent;
exports.fitWithinContainer = fitWithinContainer;
exports.constrainZoom = constrainZoom;
exports.getZoomStyle = getZoomStyle;
exports.getZoomAttr = getZoomAttr;
exports.DEFAULT_SCALE_EXTENT = void 0;

var _d3Zoom = require("d3-zoom"); // Copyright (c) 2018 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// import { TD3Transform } from './types';


var SCALE_MAX = 1;
var SCALE_MIN = 0.03;
var SCALE_MARGIN = 0.05;
var DEFAULT_SCALE_EXTENT = [SCALE_MIN, SCALE_MAX];
exports.DEFAULT_SCALE_EXTENT = DEFAULT_SCALE_EXTENT;

function boundValue(min, max, value) {
  if (value < min) {
    return min;
  }

  return value > max ? max : value;
}

function getFittedScale(width, height, viewWidth, viewHeight) {
  return Math.max(SCALE_MIN, Math.min((1 - SCALE_MARGIN) * viewWidth / width, (1 - SCALE_MARGIN) * viewHeight / height, SCALE_MAX));
}

function getScaleExtent(width, height, viewWidth, viewHeight) {
  var scaleMin = getFittedScale(width, height, viewWidth, viewHeight);
  return [scaleMin, SCALE_MAX];
}

function fitWithinContainer(width, height, viewWidth, viewHeight) {
  var scale = getFittedScale(width, height, viewWidth, viewHeight);
  var scaledHeight = scale * height;
  var scaledWidth = scale * width;
  var x = (viewWidth - scaledWidth) / 2;
  var y = (viewHeight - scaledHeight) / 2;
  return _d3Zoom.zoomIdentity.translate(x, y).scale(scale);
}

function constrainZoom(transform, width, height, viewWidth, viewHeight) {
  var tk = transform.k,
      tx = transform.x,
      ty = transform.y;
  var fittedScale = getFittedScale(width, height, viewWidth, viewHeight);
  var k = Math.max(tk, fittedScale);
  var x = boundValue(-width * k + viewWidth * 0.5, viewWidth * 0.5, tx);
  var y = boundValue(-height * k + viewHeight * 0.5, viewHeight * 0.5, ty);

  if (k !== tk || x !== tx || y !== ty) {
    return _d3Zoom.zoomIdentity.translate(x, y).scale(k);
  }

  return transform;
}

function getZoomStyle(transform) {
  if (!transform) {
    return null;
  }

  var x = transform.x,
      y = transform.y,
      k = transform.k;
  return {
    transform: "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(k, ")"),
    transformOrigin: '0 0'
  };
}

function getZoomAttr(transform) {
  if (!transform) {
    return undefined;
  }

  var x = transform.x,
      y = transform.y,
      k = transform.k;
  return "translate(".concat(x, ",").concat(y, ") scale(").concat(k, ")");
}